<template>
    <div class="myNewsDatailsBox">
        <div class="mndb_title">{{info.VTitle}}</div>
        <div class="mndb_date">{{info.createdTime}}</div>
        <div class="mndb_con">{{info.VContent}}</div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            info: {}
        }
    },
    created() {
        this.getData()
    },
    methods: {
        getData() {
            this.axios.post(window.IPConfig.IP + '/tBMessageinfo/getById.do?Id=' + this.$route.query.id).then(res => {
                if(res.status == 200) {
                    if (res.data.status == 200) {
                        this.info = res.data.obj
                        this.changeStatus()
                    }
                }
            })
        },
        changeStatus() {
            if (this.info.IState == '0') {
                this.info.IState = '1'
                this.axios.post(window.IPConfig.IP + '/tBMessageinfo/updateById.do', this.info).then(res => {
                    console.log(res,'更改结果')
                })
            }
        }
    }
}
</script>

<style>
    .myNewsDatailsBox {
        padding: 0.3rem;
        border: 0.01rem solid #ccc;
        display: flex;
        flex-direction: column;
    }
    .myNewsDatailsBox .mndb_title {
        font-size: 0.24rem;
        font-weight: 700;
        text-align: center;
    }
    .myNewsDatailsBox .mndb_date {
        width: 80%;
        text-align: right;
        padding: 0.2rem 0;
    }
    .myNewsDatailsBox .mndb_con {
        border: 0.01rem solid #ccc;
        font-size: 0.18rem;
        padding: 0.3rem;
        line-height: 0.5rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/Personalcenter/components/my/datails.vue